import _ from 'lodash';

import $ from '~/qwery';
import bean from '~/bean';
import Button from '~/components/button';
import LinkButton from '~/components/link-button';

export default class Buttons {
    constructor(el, options = {}) {
        this._options = options;
        this.$el = $(document.createElement('div'));
        this.$el.attr('class', 'b-popup-buttons');
        this.$el.html(_.template(
            '<% var tag = options["okButton"] == "button" ? "span" : "a" %>'
            + '<<%- tag %> role="<%- options["okButton"]["role"] %>"'
            + ' class="ok-button b-button">'
                + '<span class="fleck"></span>'
                + '<%- options["okButton"]["label"] %>'
            + '</<%- tag %>>'
            + '<% if (options["cancelButton"]) { %>'
                + '<% var tag = options["cancelButton"] == "button" ? "span" : "a" %>'
                + '<<%- tag %> role="<%- options["cancelButton"]["role"] %>"'
                + ' class="cancel-link-button">'
                    + '<%- options["cancelButton"]["label"] %>'
                + '</<%- tag %>>'
            + '<% } %>'
        )({options: this._options}));
        $(el).replaceWith(this.$el);

        this.$okButton = $('.ok-button', this.$el);
        this.$cancelLinkButton = $('.cancel-link-button', this.$el);
        const okButton = new Button(this.$okButton);
        const cancelLinkButton = this.$cancelLinkButton.length ?
            new LinkButton(this.$cancelLinkButton)
        : null;

        bean.on(this.$okButton[0], 'press', this._options['okButton']['onPress']);
        if (this.$cancelLinkButton.length)
            bean.on(this.$cancelLinkButton[0], 'press',
                this._options['cancelButton']['onPress']);
    }

    press(button) {
        return button == 'ok-button'
            ? this._options['okButton']['onPress']()
            : this._options['cancelButton']['onPress']();
    }
}



// WEBPACK FOOTER //
// ./makosh/assets/components/popup/buttons.js